var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFacebook = function SvgFacebook(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.729 0.566406C5.15299 0.566406 0.632812 5.09231 0.632812 10.6754C0.632812 15.7213 4.32544 19.9043 9.15381 20.6644V13.6012H6.59123V10.6811H9.15381V8.45244C9.15381 5.92091 10.6605 4.52085 12.9663 4.52085C14.0735 4.52085 15.2264 4.72086 15.2264 4.72086V7.20668H13.9537C12.698 7.20668 12.3099 7.98385 12.3099 8.78389V10.6811H15.1122L14.6671 13.6012H12.3157V20.6644C17.144 19.9043 20.8367 15.7213 20.8367 10.6754C20.8252 5.09231 16.3051 0.566406 10.729 0.566406Z",
    fill: "#4752F1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFacebook);
export default ForwardRef;